<template>
    <div>
                                                  <ValidationObserver v-slot="{ handleSubmit}">

        <CCard class="m-auto">

            <CCardHeader class="grey-header">
                <CRow class="flex-flow-column">
                    <CCol>
                        <strong>{{ $t('ticketNowPage.title')}}</strong>
                    </CCol>
                    <p class="desc">{{ $t('ticketNowPage.desc')}}</p>
                </CRow>
            </CCardHeader>

            <CCardBody class=" max-w-1100 m-auto pt-0px">
                <cPaymentList @getPaySettingsList="getPaySettList"
                              @getSelPayment="getSelectedPay"
                              :paymentFor="paymentFor"
                              :selectedPayObject="selectedPayType"
                              :selPayResDetails="selPayResDetails" @getSelPaySubDetail="getSelPaySubDet"
                />

                <div class="row mt-20px" v-if="calculatedPayFee">
                    <div class="col-md-6 mb-15px">
                        <div class="payment-few-bottom h-100">
                            <div class=" title">  {{ $t('ticketNowPage.reservationId')}}</div>
                            <div class="row flex-flow-column" style="margin-top: 40px;">
                                <div class="col-md-3">
                                    <div class="total-wrap label">
                                        <div class="row t-wrap-topup">
                                            <div class="col-6 t-title"><label>{{ $t('ticketNowPage.reservationId')}}</label></div>
                                            <div class="col-6 t-value"><label></label><label>    {{calculatedPayFee.orderId}}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="col-md-3" v-if="GET_TICKETING_QUEUE&&GET_TICKETING_QUEUE.currency">
                                    <div class="total-wrap label">
                                        <div class="row t-wrap-topup">
                                            <div class="col-6 t-title"><label>{{ $t('ticketNowPage.currency')}}</label></div>
                                            <div class="col-6 t-value"><label></label><label><span
                                                    class="bold&nbsp;transition">{{GET_TICKETING_QUEUE.currency}}</span></label></div>
                                        </div>
                                    </div>
                                </div> -->

                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 mb-15px">
                        <div class="payment-few-bottom">
                            <div class=" title">  {{$t('ticketNowPage.paymentFee')}} &amp;  {{
                                            $t('ticketNowPage.total')}}</div>
                            <div class="pay-table">
                                <table>
                                    <tbody>
                                    <tr>
                                        <td>
                                            {{
                                            $t('ticketNowPage.amount')}}
                                        </td>
                                        <td  >
                                            <div v-if="GET_TICKETING_QUEUE&&GET_TICKETING_QUEUE.currency">
                                                {{GET_TICKETING_QUEUE.currency}}
                                            </div>

                                        </td>
                                        <td>
                                            <div v-if="GET_TICKETING_QUEUE&&GET_TICKETING_QUEUE.currency">
                                           {{calculatedPayFee.orderAmount|formatNumber(GET_TICKETING_QUEUE.currency)}}
                                            </div>

                                        </td>
                                    </tr>
                                    <tr v-if="calculatedPayFee.fee">
                                        <td>
                                            {{
                                            $t('ticketNowPage.paymentFees')}}
                                        </td>
                                        <td>
                                           <div v-if="GET_TICKETING_QUEUE&&GET_TICKETING_QUEUE.currency">
                                               {{GET_TICKETING_QUEUE.currency}}
                                           </div>
                                        </td>
                                        <td>
                                            <number
                                                        class="bold transition"
                                                        
                                                        ref="totalPaxNum"
                                                        :from="0"
                                                        :format="theFormat"
                                                        :animationPaused="false"
                                                        :to="calculatedPayFee.fee"
                                                        :duration="0.5"
                                                        easing="Power4.easeOut"
                                                       />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            {{ $t('ticketNowPage.total')}}
                                        </td>
                                        <td>
                                            <div v-if="GET_TICKETING_QUEUE&&GET_TICKETING_QUEUE.currency">{{GET_TICKETING_QUEUE.currency}}</div>
                                        </td>
                                        <td>
                                            <number
                                                        class="bold transition"
                                                        
                                                        ref="totalPaxNum"
                                                        :from="0"
                                                        :format="theFormat"
                                                        :animationPaused="false"
                                                        :to="calculatedPayFee.total"
                                                        :duration="0.5"
                                                        easing="Power4.easeOut"
                                                       />
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
<!--                            <div class="row flex-flow-column">-->
<!--                                <div class="col-md-3">-->
<!--                                    <div class="total-wrap label">-->

<!--                                        <div class="row t-wrap-topup">-->
<!--                                            <div class="col-6 t-title"><label>{{-->
<!--                                                $t('ticketNowPage.amount')}}</label></div>-->
<!--                                            <div class="col-6 t-value"-->
<!--                                                 v-if="GET_TICKETING_QUEUE&&GET_TICKETING_QUEUE.currency">-->
<!--                                                <label>{{GET_TICKETING_QUEUE.currency}}</label><label>-->
<!--                                                {{calculatedPayFee.orderAmount|formatNumber(GET_TICKETING_QUEUE.currency)}}</label>-->
<!--                                            </div>-->
<!--                                            <div class="col-6 t-value" v-else><label v-if="GET_TICKETING_QUEUE&&GET_TICKETING_QUEUE.currency">{{GET_TICKETING_QUEUE.currency}}</label><label>-->
<!--                                                {{calculatedPayFee.orderAmount}}</label></div>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-md-3">-->
<!--                                    <div class="total-wrap label">-->

<!--                                        <div class="row t-wrap-topup">-->
<!--                                            <div class="col-6 t-title"><label>{{-->
<!--                                                $t('ticketNowPage.paymentFees')}}</label></div>-->
<!--                                            <div class="col-6 t-value" v-if="calculatedPayFee.fee">-->
<!--                                                <label v-if="GET_TICKETING_QUEUE&&GET_TICKETING_QUEUE.currency">{{GET_TICKETING_QUEUE.currency}}</label><label>-->
<!--                                                <number-->
<!--                                                            class="bold transition"-->
<!--                                                            -->
<!--                                                            ref="totalPaxNum"-->
<!--                                                            :from="0"-->
<!--                                                            :format="theFormat"-->
<!--                                                            :animationPaused="false"-->
<!--                                                            :to="calculatedPayFee.fee"-->
<!--                                                            :duration="0.5"-->
<!--                                                            easing="Power4.easeOut"-->
<!--                                                           />-->
<!--                                            </label></div>-->
<!--                                            <div class="col-6 t-value"-->
<!--                                                 v-if="!calculatedPayFee.fee&&GET_TICKETING_QUEUE.currency"><label v-if="GET_TICKETING_QUEUE&&GET_TICKETING_QUEUE.currency">{{GET_TICKETING_QUEUE.currency}}</label><label> {{calculatedPayFee.fee.toString()|formatNumber(GET_TICKETING_QUEUE.currency)}}</label>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-md-3">-->
<!--                                    <div class="total-wrap label">-->

<!--                                        <div class="row t-wrap-topup">-->
<!--                                            <div class="col-6 t-title"><label>{{ $t('ticketNowPage.total')}}</label>-->
<!--                                            </div>-->
<!--                                            <div class="col-6 t-value"><label v-if="GET_TICKETING_QUEUE&&GET_TICKETING_QUEUE.currency">{{GET_TICKETING_QUEUE.currency}}</label><label>  -->
<!--                                                <number-->
<!--                                                            class="bold transition"-->
<!--                                                            -->
<!--                                                            ref="totalPaxNum"-->
<!--                                                            :from="0"-->
<!--                                                            :format="theFormat"-->
<!--                                                            :animationPaused="false"-->
<!--                                                            :to="calculatedPayFee.total"-->
<!--                                                            :duration="0.5"-->
<!--                                                            easing="Power4.easeOut"-->
<!--                                                           />-->
<!--                                            </label></div>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->

<!--                            </div>-->
                        </div>
                    </div>
                </div>
<!--                <div class="ticket_now_total_sum" >-->


<!--                    <div class="card-sec-title"></div>-->
<!--                    <div class="payment-details">-->
<!--                        <label for="" class="box-title">-->
<!--                            {{ $t('ticketNowPage.paymentDetails')}}-->
<!--                        </label>-->
<!--                        <div class="pay-detail-wrapper">-->
<!--                            <div class="card-wrapper-py">-->
<!--                                <div class="invi-card">-->
<!--                                    <div class="wrap">-->
<!--                                        <label for="">{{ $t('ticketNowPage.reservationId')}}</label>-->
<!--                                        <div class="value">-->
<!--                                            {{calculatedPayFee.orderId}}-->
<!--                                        </div>-->
<!--                                    </div>-->

<!--                                </div>-->
<!--                                <div class="invi-card" v-if="GET_TICKETING_QUEUE&&GET_TICKETING_QUEUE.currency">-->
<!--                                    <div class="wrap">-->
<!--                                        <label for="" >{{ $t('ticketNowPage.currency')}}</label>-->
<!--                                        <div class="value">-->


<!--                                            {{GET_TICKETING_QUEUE.currency}}-->
<!--                                        </div>-->

<!--                                    </div>-->

<!--                                </div>-->
<!--                                <div class="invi-card">-->
<!--                                    <div class="wrap">-->
<!--                                        <label for="">{{ $t('ticketNowPage.amount')}}</label>-->
<!--                                        <div class="value" v-if="GET_TICKETING_QUEUE&&GET_TICKETING_QUEUE.currency">-->


<!--                                            {{calculatedPayFee.orderAmount|formatNumber(GET_TICKETING_QUEUE.currency)}}-->
<!--                                        </div>-->
<!--                                        <div class="value" v-else>-->


<!--                                            {{calculatedPayFee.orderAmount}}-->
<!--                                        </div>-->

<!--                                    </div>-->

<!--                                </div>-->

<!--                                <div class="invi-card">-->
<!--                                    <div class="wrap">-->
<!--                                        <label for="">{{ $t('ticketNowPage.paymentFees')}}</label>-->
<!--                                        <div class="value" v-if="calculatedPayFee.fee">-->
<!--                                             -->
<!--                                            <number-->
<!--                                                        class="bold transition"-->
<!--                                                        -->
<!--                                                        ref="totalPaxNum"-->
<!--                                                        :from="0"-->
<!--                                                        :format="theFormat"-->
<!--                                                        :animationPaused="false"-->
<!--                                                        :to="calculatedPayFee.fee"-->
<!--                                                        :duration="0.5"-->
<!--                                                        easing="Power4.easeOut"-->
<!--                                                       />-->
<!--                                        </div>-->
<!--                                        <div class="value" v-if="!calculatedPayFee.fee&&GET_TICKETING_QUEUE.currency">-->
<!--                                             {{calculatedPayFee.fee.toString()|formatNumber(GET_TICKETING_QUEUE.currency)}}-->
<!--                                        </div>-->
<!--                                    </div>-->

<!--                                </div>-->

<!--                            </div>-->
<!--                            <div class="single card">-->
<!--                                <div class="invi-card">-->
<!--                                    <div class="wrap">-->
<!--                                        <label for="">{{ $t('ticketNowPage.total')}}</label>-->
<!--                                        <span class="value">-->
<!--                         <number-->
<!--                                                    class="bold transition"-->
<!--                                                    -->
<!--                                                    ref="totalPaxNum"-->
<!--                                                    :from="0"-->
<!--                                                    :format="theFormat"-->
<!--                                                    :animationPaused="false"-->
<!--                                                    :to="calculatedPayFee.total"-->
<!--                                                    :duration="0.5"-->
<!--                                                    easing="Power4.easeOut"-->
<!--                                                   />-->
<!--                    </span>-->
<!--                                    </div>-->

<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->

<!--                    </div>-->

                    <!--                    <table>-->
                    <!--                        <tbody>-->
                    <!--                        <tr>-->
                    <!--                            <td>-->
                    <!--                                <div class="wrapper">-->
                    <!--                                    <div>{{ $t('ticketNowPage.reservationId')}}</div>-->
                    <!--                                </div>-->
                    <!--                            </td>-->
                    <!--                            <td></td>-->

                    <!--                            <td>-->
                    <!--                                <div class="value">{{calculatedPayFee.orderId}}</div>-->
                    <!--                            </td>-->
                    <!--                        </tr>-->

                    <!--                        <tr>-->
                    <!--                            <td>-->
                    <!--                                <div class="wrapper">-->
                    <!--                                    <div>{{ $t('ticketNowPage.amount')}}</div>-->
                    <!--                                </div>-->
                    <!--                            </td>-->
                    <!--                            <td></td>-->
                    <!--                            <td>-->
                    <!--                                <div class="value">{{calculatedPayFee.orderAmount}}</div>-->
                    <!--                            </td>-->
                    <!--                        </tr>-->
                    <!--                        <tr>-->
                    <!--                            <td>-->
                    <!--                                <div class="wrapper">-->
                    <!--                                    <div>{{ $t('ticketNowPage.paymentFees')}}</div>-->
                    <!--                                </div>-->
                    <!--                            </td>-->
                    <!--                            <td></td>-->
                    <!--                            <td>-->
                    <!--                                <div class="value">-->
                    <!--                                     <number-->
                    <!--                                            class="bold transition"-->
                    <!--                                            -->
                    <!--                                            ref="totalPaxNum"-->
                    <!--                                            :from="0"-->
                    <!--                                            :format="theFormat"-->
                    <!--                                            :animationPaused="false"-->
                    <!--                                            :to="calculatedPayFee.fee"-->
                    <!--                                            :duration="0.5"-->
                    <!--                                            easing="Power4.easeOut"-->
                    <!--                                           />-->

                    <!--&lt;!&ndash;                                    {{calculatedPayFee.fee}}&ndash;&gt;-->
                    <!--                                </div>-->
                    <!--                            </td>-->
                    <!--                        </tr>-->

                    <!--                        <tr>-->
                    <!--                            <td>-->
                    <!--                                <div class="wrapper">-->
                    <!--                                    <div>{{ $t('ticketNowPage.total')}}</div>-->
                    <!--                                </div>-->
                    <!--                            </td>-->
                    <!--                            <td></td>-->
                    <!--                            <td>-->
                    <!--                                <div class="value">-->
                    <!--                                     <number-->
                    <!--                                            class="bold transition"-->
                    <!--                                            -->
                    <!--                                            ref="totalPaxNum"-->
                    <!--                                            :from="0"-->
                    <!--                                            :format="theFormat"-->
                    <!--                                            :animationPaused="false"-->
                    <!--                                            :to="calculatedPayFee.total"-->
                    <!--                                            :duration="0.5"-->
                    <!--                                            easing="Power4.easeOut"-->
                    <!--                                           />-->
                    <!--&lt;!&ndash;                                    {{calculatedPayFee.total}}&ndash;&gt;-->
                    <!--                                </div>-->
                    <!--                            </td>-->
                    <!--                        </tr>-->
                    <!--                        </tbody>-->
                    <!--                    </table>-->
<!--                </div>-->

            </CCardBody>

            <footer class="card-footer " v-if="!isHideFooter">

                        
                <div class="row mob-flex-column">
                    <div class="text-right mob-btn-center col">
                        <div class="row ">
                            <CCol md="12" class="d-flex justify-content-between align-items-center">
                                <CButton @click="navigateToPrevPage"
                                         class="btn align-right btn-lit-blue btn-success m-10px bg-danger ml-0px">
                <span>
                        {{ $t('ticketNowPage.goBack') }}
                </span>
                                </CButton>
                                <button v-if="isPaySubmitted" type="submit"
                                        class="btn buttonspace action-c-btn btn-success removewrap h-40px"
                                        @click.once="handleSubmit(onSubmitPayForTicketing),reCreatePayBtn();"><img
                                        src="/img/correct.0d4e03c5.svg">{{ $t('ticketNowPage.payBtn')}}
                                </button>
                            </CCol>


                        </div>
                    </div>
                </div>
            </footer>

        </CCard>
                                                      <br />
                                    </ValidationObserver>


        <cAlertModal v-if="isBookFailAlert"
                     :show="isBookFailAlert"
                     :status="0"
                     :buttonList="getBookFailModalBtns()"
                     :desc="alertValue"
        ></cAlertModal>
        <cAlertModal v-if="isAlertWhileNav"
                     :buttonList="[
      { name:$t('ticketNowPage.okBtn'),func: navToResultPage,color: 'danger'},]"
                     :show="isAlertWhileNav"
                     :status="0"
                     :desc="alertValue"
        ></cAlertModal>

        <cAlertModal v-if="isSelPaymentAlert"
                     :buttonList="[
      { name:$t('ticketNowPage.selPayAlertOkBtn'),func: onHideSelPaymentAlert,color: 'danger'},]"
                     :show="isSelPaymentAlert"
                     :status="0"
                     :desc="$t('ticketNowPage.selectPayAlert')"
        ></cAlertModal>
        <!-- <button v-if="isPaySubmitted" @click.once="onSubmitPayForTicketing">{{ $t('ticketNowPage.payBtn')}}</button> -->
    </div>
</template>
<script>
import BaseConfiguration from "../../../../config/base";
import Logger from "../../../../services/logger";
import apiSelectPayForTicketing from "../../../../services/apiSelectPayForTicketing";
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "@/util/apiValidate.js";
import router, { navigate, goBack, updateDataEdited } from "../../../../router/index";

import cAlertModal from "../../../../components/form/cAlertModal";

import cPaymentList from "../../../../components/payment/cPaymentList";
import { mapGetters, mapActions } from "vuex";
import {
  handleJWT,
  getErrorAlertValue,
  cloneData,
  addClassToBody,
  removeClassBody,
  handleSessionExist,
  navigateByHostUrl,
  cloneDeep
} from "../../../../util/util";
import cPerPaxPriceInfo from "../../../../components/result/cPerPaxPriceInfo";
import cTotalPriceInfo from "../../../../components/result/cTotalPriceInfo";
import cSelFlightInfo from "../../../../components/result/cSelFlightInfo";
import apiCreatePaymentForTicketing from "../../../../services/apiCreatePaymentForTicketing";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../../../config/API_DATA";
import {
  COMPONENT_NAME,
  PATHNAME,
  ROUTER_PARAM,
  PAX,
  TOAST_TYPE,
  PROCEED_TO_TYPE,
  PAYMENT_FOR,
  GENDER,BOOKING_STATUS
} from "../../../../util/constants";
import apiGetTicketingQueueList from "../../../../services/apiGetTicketingQueueList";
    import {ValidationObserver, localize, Validator} from "vee-validate";
    import Vue from 'vue';

export default {
  components: {
    cPaymentList,
    cSelFlightInfo,
    cPerPaxPriceInfo,
    cTotalPriceInfo,
    cAlertModal,
    ValidationObserver
  },
  computed: {
    ...mapGetters("sTicketingQueue", {
      GET_TICKETING_QUEUE: "GET_TICKETING_QUEUE"
    }),
    ...mapGetters("sPaymentPage", {
      sSelectedPayTypeObj: "GET_SEL_PAY_TYPE_OBJ"
    }),
     ...mapGetters("sAgtLogin", {
      sSignInRes: "GET_SIGNIN_RES"
    }),
     ...mapGetters("sAgtLogin", {
      AGENT_SIGNIN_RES: "GET_SIGNIN_RES"
    }),
    ...mapGetters("sDashBoard", {
      AGENT_DET: "GET_AGENT_LOGO_DET_RES"
    }),
      ...mapGetters("cTicketingDetail", {
                GET_TICKETING_SEARCH_OBJ: "GET_FILTER_SEARCH_OBJ",


            }),
    // ...mapGetters("sResult", {
    //     selectedFlight: "GET_SEL_FLI_FRM_PRIC",
    //     // searchPricingReq: "GET_SEARCH_PRICING_REQ"
    //   }),
  },
  data: () => ({
    paymentFor: PAYMENT_FOR.TICKET_NOW,
    selectedPayType: {
      paymentsettingsid: null,
      groupId: null,
            providertype:null

    },
    alertValue: null,
    calculatedPayFee: null,
     isSelPaymentAlert: false, /// show alert to select payment type
    isAlertWhileNav: false, //get confirmation before navigating to results page
    bookingResponse: null, //createBookingRes
        isBookFailAlert: false,
            isPaySubmitted:true,
            isHideFooter:false,
    selPayResDetails:null,
    selPaySubDetail:null

  }),


  methods: {
    ...mapActions("sPaymentPage", {
      SET_PAY_TYPE_OBJ: "SET_PAY_TYPE_OBJ",
      SET_CREATE_BOOKING_RES:"SET_CREATE_BOOKING_RES",
      SET_CREATE_BOOKING_REQ:"SET_CREATE_BOOKING_REQ"
    }),
    ...mapActions("cTicketingDetail", {
     SET_FILTER_SEARCH_OBJ: "SET_FILTER_SEARCH_OBJ",
     SET_TICKETING_QUEUE_RES:"SET_TICKETING_QUEUE_RES"
    }),
     theFormat(number) {
       if(this.GET_TICKETING_QUEUE&&this.GET_TICKETING_QUEUE.currency){
      return this.$options.filters.formatNumber(number,this.GET_TICKETING_QUEUE.currency);

       }
    },

     navigateToPrevPage() {
                try {
                    if (BaseConfiguration.isDebug) console.log("navigateToPrevPage");

                    goBack();
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.TICKET_NOW,
                        "error in navigateToPrevPage",
                        err.toString(),
                        "navigateToPrevPage",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },
  getPaySettList(pPaySettingsLs) {
    try {
      if(BaseConfiguration.isDebug) console.log("getPaySettList");
      if(!(pPaySettingsLs&&pPaySettingsLs.length>0)){
                this.isHideFooter=true;
              }

    } catch (err) {
            let body = Logger.buildRequest(
              COMPONENT_NAME.TICKET_NOW,
              "error in getPaySettList",
              err.toString(),
              "getPaySettList",
              LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
          }
     
    }, 
    getSelPaySubDet(pDetails) {
        try {
          if(BaseConfiguration.isDebug) console.log("getSelPaySubDet");
         this.selPaySubDetail= pDetails;
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.PAYMENTPAGE,
                  "error in getSelPaySubDet",
                  err.toString(),
                  "getSelPaySubDet",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         
        }, 
    getDetailsForSelpaySubcard(pSelectedPayRes,pTickQueueObj) {
       let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("getDetailsForSelpaySubcard");
          if(pSelectedPayRes.total){
          retValue={};
                    retValue.total=pSelectedPayRes.total;
                     retValue.currency=pTickQueueObj.currency;
             
              if(pTickQueueObj.journeytype==2){
               retValue.remarks= pTickQueueObj.FlightDetails[0].departure+' - '+pTickQueueObj.FlightDetails[pTickQueueObj.FlightDetails.length-1].departure;
              }else{
                retValue.remarks= pTickQueueObj.FlightDetails[0].departure+' - '+pTickQueueObj.FlightDetails[pTickQueueObj.FlightDetails.length-1].arrival;
              }
     
          }
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.PAYMENTPAGE,
                  "error in getDetailsForSelpaySubcard",
                  err.toString(),
                  "getDetailsForSelpaySubcard",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
        }, 
    async getSelectedPay(pPaymentType) {
      try {
        if (BaseConfiguration.isDebug) console.log("getSelectedPay");
        this.selectedPayType.paymentsettingsid = pPaymentType.paymentsettingsid;
        this.selectedPayType.groupId = pPaymentType.groupId;
         this.selectedPayType.providertype=pPaymentType.providertype;
        let retSelectedPayment = await this.getSelectPayForTicketing(
          pPaymentType.paymentsettingsid,
          this.GET_TICKETING_QUEUE.orderId
        );
      

                if (retSelectedPayment) {
        this.calculatedPayFee = retSelectedPayment;
                  
                       let selPayDetails= this.getDetailsForSelpaySubcard(retSelectedPayment,this.GET_TICKETING_QUEUE);
            if(selPayDetails){
               this.selPayResDetails=selPayDetails;
             }
          //  this.calculatedPayFee = null;
          //   setTimeout(() => {
          //     that.calculatedPayFee = retSelectedPayment;
          //   });
          
          }
       updateDataEdited(true);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TICKET_NOW,
          "error in getSelectedPay",
          err.toString(),
          "getSelectedPay",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    

    async getSelectPayForTicketing(pPaymentsettingsid, pOrderId) {
      try {
        let retValue;
        if (BaseConfiguration.isDebug) console.log("getSelectPayForTicketing");
        let selectPayRequest = apiSelectPayForTicketing.buildRequest(
          pOrderId,
          pPaymentsettingsid
        );

        if (selectPayRequest) {
          let selectPayResponse = await apiSelectPayForTicketing.getResponse(
            selectPayRequest
          );
          // let selectPayResponse = {
          //   data: {
          //     data: {
          //       orderId: "MF1327",
          //       orderAmount: 95.62,
          //       fee: 1.69,
          //       total: 97.31,
          //       feeId: 1
          //     },
          //     status: "Success"
          //   }
          // };

          if (VALIDATE_SUCCESS_RES(selectPayResponse)) {
            //VALIDATE_SUCCESS_RES(selectPayResponse)
            retValue = selectPayResponse.data.data;
          } else {
            let error = getErrorMessage(selectPayResponse);
            // if (retSessionVal) {
            //   this.showToast(retSessionVal, TOAST_TYPE.ERROR, 5000, null);
            // }
            let isJwt = handleJWT(error);
            if (!isJwt && selectPayResponse) {
              let isSessionExpired = handleSessionExist(selectPayResponse.data);
              if (!isSessionExpired) {
                this.alertValue = getErrorAlertValue(error);
              }
            }
          }
        } else {
          throw "invalid select payment request";
        }
        return retValue;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TICKET_NOW,
          "error in getSelectPayForTicketing",
          err.toString(),
          "getSelectPayForTicketing",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

     async getTicketingQueueList(ticketingObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("getTicketingQueueList");
        //let retValue;
        //let TicketQList;
        this.SET_FILTER_SEARCH_OBJ(ticketingObj);
        if(this.AGENT_SIGNIN_RES && this.AGENT_DET){
          ticketingObj.b2bid = this.AGENT_DET.b2bid;
        }
        let ticketQReq = apiGetTicketingQueueList.buildRequest(ticketingObj);

        if (ticketQReq) {
          let ticketQRes = await apiGetTicketingQueueList.getResponse(
            ticketQReq
          );
          if (VALIDATE_SUCCESS_RES(ticketQRes)) {
            this.SET_TICKETING_QUEUE_RES(ticketQRes.data.data)

          } else {
            let error = getErrorMessage(ticketQRes);
            let isJwt = handleJWT(error);
            if (!isJwt) {
             getErrorAlertValue(error);
            }
          }
        } else {
          throw "invalid request";
        }

        //return TicketQList;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TICKET_NOW,
          "error in getTicketingQueueList",
          err.toString(),
          "getTicketingQueueList",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      // return retValue;
    },
    getSelSubDetailsForReq(pSelPaySubDetail) {
          let retValue;

        try {
          if(BaseConfiguration.isDebug) console.log("getSelSubDetailsForReq");
    retValue={
            "ref_staffName":pSelPaySubDetail.ref_staffName?pSelPaySubDetail.ref_staffName:null,
                    "remarks": pSelPaySubDetail.remarks?pSelPaySubDetail.remarks:null,
                    "subAgentId": pSelPaySubDetail.selSubAgent&&pSelPaySubDetail.selSubAgent.id?pSelPaySubDetail.selSubAgent.id:null,
                    "paidAmount":pSelPaySubDetail.paidAmount?Number(pSelPaySubDetail.paidAmount):null
          };
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.TICKET_NOW,
                  "error in getSelSubDetailsForReq",
                  err.toString(),
                  "getSelSubDetailsForReq",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
        }, 

    async onSubmitPayForTicketing() {
      try {
        if (BaseConfiguration.isDebug) console.log("onSubmitPayForTicketing");
 updateDataEdited(false);
        if (
          this.selectedPayType.paymentsettingsid &&
          this.selectedPayType.groupId
        ) {
          let selPaySubDetail=this.getSelSubDetailsForReq(cloneData(this.selPaySubDetail));
          let isRetryPayment=this.GET_TICKETING_QUEUE&&this.GET_TICKETING_QUEUE.status==BOOKING_STATUS.PAYMENT_STATUS_PENDING?true:false;
          let retBookingResponse = await this.createBookingForTicketing(
            this.GET_TICKETING_QUEUE.orderId,
            this.selectedPayType.paymentsettingsid,isRetryPayment,selPaySubDetail
          );

          if (retBookingResponse) {
            this.bookingResponse = retBookingResponse;
            if(this.GET_TICKETING_SEARCH_OBJ){
           await this.getTicketingQueueList(this.GET_TICKETING_SEARCH_OBJ);

            }
            this.navByProceedTo(this.bookingResponse.bookingStatus);
          } else {
             this.reCreatePayBtn();
            this.toggleBookFailAlert();
          }
        } else {
           this.reCreatePayBtn();
          this.isSelPaymentAlert = true;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TICKET_NOW,
          "error in onSubmitPayForTicketing",
          err.toString(),
          "onSubmitPayForTicketing",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
   reCreatePayBtn() {
        try {
          if(BaseConfiguration.isDebug) console.log("reCreatePayBtn");
          addClassToBody(COMPONENT_NAME.TICKET_NOW);
           this.isPaySubmitted=false;
             let that = this;
    Vue.nextTick(() => {
     that.isPaySubmitted = true;
    },100);
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.TICKET_NOW,
                  "error in reCreatePayBtn",
                  err.toString(),
                  "reCreatePayBtn",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         
        }, 
    ///to call create payment for ticketing api
    async createBookingForTicketing(pOrderId,pPaymentSettingsId,pIsRetryPayment,pSelPaySubDetail) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("createBookingForTicketing");
    

        let bookingReq = apiCreatePaymentForTicketing.buildRequest(pOrderId,pPaymentSettingsId,pIsRetryPayment,pSelPaySubDetail);

        if (bookingReq) {
          let bookingRes = await apiCreatePaymentForTicketing.getResponse(
            bookingReq
          );
                      this.SET_CREATE_BOOKING_REQ(bookingReq);


          if (VALIDATE_SUCCESS_RES(bookingRes)) {//VALIDATE_SUCCESS_RES(bookingRes)
            this.SET_CREATE_BOOKING_RES(bookingRes);

            if (BaseConfiguration.isDebug) {
              if (
                // to print PNRs in console
                bookingRes && 
                bookingRes.data &&
                bookingRes.data.data &&
                bookingRes.data.data.bookingStatus &&
                bookingRes.data.data.bookingStatus.BookingDetails
              ) {
                for (
                  let t = 0;
                  t < bookingRes.data.data.bookingStatus.BookingDetails.length;
                  t++
                ) {
                  console.log(
                    JSON.stringify(
                      bookingRes.data.data.bookingStatus.BookingDetails[t].pnr
                    )
                  );
                }
              }
            }

            ///if booked is true
            if (bookingRes && bookingRes.data &&
              bookingRes.data.data &&
              bookingRes.data.data.isBooked
            ) {
              retValue = bookingRes.data.data;
            } ///if booked false ,but status success
            else {
              addClassToBody(COMPONENT_NAME.TICKET_NOW);
              retValue = bookingRes.data.data;
              this.handleBookingFailed(retValue);
            }
          } else {
            //if status error
            addClassToBody(COMPONENT_NAME.TICKET_NOW);
            retValue = null;
            let error = getErrorMessage(bookingRes);

            let isJwt = handleJWT(error);
            if (!isJwt && bookingRes) {
              let isSessionExpired = handleSessionExist(bookingRes.data);
              if (!isSessionExpired) {
                this.alertValue = getErrorAlertValue(error,true,true);
              }
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TICKET_NOW,
          "error in getting response from create booking API",
          err.toString(),
          "createBookingForTicketing",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
     ///to handling the failed case of booking
    handleBookingFailed(pBookingRes) {
      try {
        if (BaseConfiguration.isDebug) console.log("handleBookingFailed");

        //if status success, but it contains error obj
        let errList = [];
        if (
          pBookingRes.hasOwnProperty("bookingStatus") &&
          pBookingRes.bookingStatus.BookingDetails
        ) {
          for (
            let i = 0;
            i < pBookingRes.bookingStatus.BookingDetails.length;
            i++
          ) {
            if (
              pBookingRes.bookingStatus.BookingDetails[i].hasOwnProperty(
                "error"
              )
            ) {
              if (
                pBookingRes.bookingStatus.BookingDetails[i].error &&
                pBookingRes.bookingStatus.BookingDetails[i].error
                  .constructor === Array
              ) {
                for (
                  let j = 0;
                  j < pBookingRes.bookingStatus.BookingDetails[i].error.length;
                  j++
                ) {
                  errList.push(
                    pBookingRes.bookingStatus.BookingDetails[i].error[j]
                  );
                }
              } else {
                errList.push(pBookingRes.bookingStatus.BookingDetails[i].error);
              }
            } else {
              this.alertValue = this.$t('ticketNowPage.cantBook');
            }
          }
        }
        this.alertValue = errList;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TICKET_NOW,
          "error in handleBookingFailed",
          err.toString(),
          "handleBookingFailed",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
///to assign particular values to query to navigate another domain
    getPayQueryValues(pBookingStatus) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getPayQueryValues");

        let param = {};
        if (pBookingStatus) {
          // param[ROUTER_PARAM.SESSION] = this.$router.currentRoute.query[
          //   ROUTER_PARAM.SESSION_ID
          // ];
          param[ROUTER_PARAM.PROVIDER_ID] = pBookingStatus.paymentProviderId;
          param[ROUTER_PARAM.ORDER_PAYMENT_ID] = pBookingStatus.orderPaymentId;
          param[ROUTER_PARAM.TOKEN] = this.sSignInRes.authorization;

          if(BaseConfiguration.paymentDebugUrl!=null) {
            param[ROUTER_PARAM.PAYMENT_DEBUG_URL] = BaseConfiguration.paymentDebugUrl;
          }
          
          retValue = param;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TICKET_NOW,
          "error in getPayQueryValues",
          err.toString(),
          "getPayQueryValues",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },


   ///navigate to corresponding pages using proceedTo from booking response
    navByProceedTo(pBookingStatus) {
      
      try {
        if (BaseConfiguration.isDebug) console.log("navByProceedTo");
        
        switch (pBookingStatus.proceedTo) {
          case PROCEED_TO_TYPE.HOLD_PAGE:
            {
              navigate(PATHNAME.HOLDPAGE);
            }
            break;
          case PROCEED_TO_TYPE.FLIGHT_RESULTS_PAGE:
            {
              if (this.alertValue && !pBookingStatus.isBooked) {
                //if booked failed,having error and proceedTo FlightResultPage

                this.toggleAlertWhileNav(); ///show alert and navigate to resultpage
              }
            }
            break;
          case PROCEED_TO_TYPE.PAYMENT_GATEWAY:
            {
              let retQuery = this.getPayQueryValues(pBookingStatus);

              if (retQuery) {
                navigateByHostUrl(PATHNAME.PAYMENTGATEWAY,retQuery,false);
              } else {
                throw "invalid queries";
              }
            }
            break;
          case PROCEED_TO_TYPE.TICKET_SUCCESS_PAGE:
            {
              navigate(PATHNAME.SUCCESSPAGE);
            }
            break;

          default:
            addClassToBody(COMPONENT_NAME.TICKET_NOW);
            throw "invalid navigation proceed ";
            break;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TICKET_NOW,
          "error in navByProceedTo",
          err.toString(),
          "navByProceedTo",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getBookFailModalBtns() {
      
      return [
        {
          name: this.$t("ticketNowPage.okBtn"),
          func: this.reloadCurrentPage,
          color: "danger"
        }
      ];
    },
   
   reloadCurrentPage() {
       try {
         if(BaseConfiguration.isDebug) console.log("reloadCurrentPage");
         this.$router.go();
   
       } catch (err) {
               let body = Logger.buildRequest(
                 COMPONENT_NAME.TICKET_NOW,
                 "error in reloadCurrentPage",
                 err.toString(),
                 "reloadCurrentPage",
                 LOG_TYPE.ERROR
               );
               Logger.getResponse(body);
             }
       }, 

    ///to navigate flightResult page from alert
    navToResultPage() {
      try {
        if (this.$route.path != PATHNAME.FLIGHTRESULTS) {
          navigate(PATHNAME.FLIGHTRESULTS);
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TICKET_NOW,
          "error in navToResultPage",
          err.toString(),
          "navToResultPage",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    ///to show alert,if booking response status error
    onHideSelPaymentAlert() {
      try {
        if (BaseConfiguration.isDebug) console.log("onHideSelPaymentAlert");

        this.isSelPaymentAlert = false;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TICKET_NOW,
          "error in onHideSelPaymentAlert",
          err.toString(),
          "onHideSelPaymentAlert",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    ///to show alert,if booking response status error
    toggleBookFailAlert() {
      try {
        if (BaseConfiguration.isDebug) console.log("toggleBookFailAlert");

        this.isBookFailAlert = !this.isBookFailAlert;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TICKET_NOW,
          "error in toggleBookFailAlert",
          err.toString(),
          "toggleBookFailAlert",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    ///show alert to navigate to resultpage
    toggleAlertWhileNav() {
      try {
        if (BaseConfiguration.isDebug) console.log("toggleAlertWhileNav");

        this.isAlertWhileNav = !this.isAlertWhileNav;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TICKET_NOW,
          "error in toggleAlertWhileNav",
          err.toString(),
          "toggleAlertWhileNav",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    // ///to assign particular values to query to navigate another domain
    // getPayQueryValues(pBookingStatus) {
    //   let retValue;
    //   try {
    //     if (BaseConfiguration.isDebug) console.log("getPayQueryValues");

    //     let param = {};
    //     if (pBookingStatus) {
    //       param[ROUTER_PARAM.SESSION] = this.$router.currentRoute.query[
    //         ROUTER_PARAM.SESSION_ID
    //       ];
    //       param[ROUTER_PARAM.PROVIDER_ID] = pBookingStatus.paymentProviderId;
    //       param[ROUTER_PARAM.ORDER_PAYMENT_ID] = pBookingStatus.orderPaymentId;
    //       param[ROUTER_PARAM.TOKEN] = this.sSignInRes.authorization;
    //       retValue = param;
    //     }
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       COMPONENT_NAME.TICKET_NOW,
    //       "error in getPayQueryValues",
    //       err.toString(),
    //       "getPayQueryValues",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    //   return retValue;
    // },
  },
   beforeCreate() {    
   addClassToBody(COMPONENT_NAME.TICKET_NOW);
  },
  
   beforeDestroy() {
       removeClassBody();
    },
    // created(){
    //   console.error(this.GET_TICKETING_QUEUE)
    // }
};
</script>

<style>
    .paymentFeeTag {
        min-height: 1px;
        width: calc(100% - 40px);
        border-top: dashed 2px #d7d9dd;
        position: absolute;
        /*bottom: 65px;*/
        top: 133px;
    }
</style>
